<template>
  <div>
    <user-detail-title
      first-bread="首页管理"
      second-bread="资质信誉"
      third-bread="资质信誉添加"
      first-url="/user/sign"
      second-url="/user/quality"
      title-name="资质信誉添加"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="图片">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="Alist.type" placeholder="请选择">
            <el-option
              v-for="item in BelongData"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input  type="textarea"
                     :rows="4"
                     v-model="Alist.description" ></el-input>
        </el-form-item>
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "QualityAdd",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        BelongData:null,
        Alist: {
          'photoUrl':null,
          'type':null,
          'description':null,
        },//表示Add添加的数据
      }
    },
    created() {
      this.GetBelong()
    },
    methods:{
      GetUrlList(file){
        this.Alist.photoUrl=file.data;
      },
      GetBelong(){
        this.$axios.get('/api/certification/getTypeList').then(res=>{
          this.BelongData=res.data.data;
        })
      },
      handleAdd(){
        this.$axios.post('/api/certification/add',this.Alist).then(res=>{
          if(res.data.success == true){
            this.Alist= {
              'photoUrl':null,
              'type':null,
              'description':null,
            }//表示Add添加的数据,
              this.$message({
                message:'添加成功',
                type:'success'
              })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>